export default {
  getConferencias: state => state.conferencias,
  getConferenciaById: state => _id => {
    const indexConferencia = state.conferencias.findIndex(conferencia => conferencia._id === _id)
    return state.conferencias[indexConferencia].description
  },
  getDadosRelatorioConferencia: state => state.dadosRelatorioConferencia,
}
